import React from 'react';
import { useNavigate } from 'react-router-dom';
import appstore from '../assets/images/appstore.png';
import playstore from '../assets/images/playstore.png';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/');
  };

  // App store links - replace with your actual links
  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/app/id6744721098', '_blank');
  };

  const handlePlayStoreClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.mnk.vreels', '_blank');
  };

  return (
    <div className="signup-instructions-container">
      <div className="signup-instructions-content">
        <div className="instructions-section">
          <div className="instructions-header">
            <h1 className="instructions-title">Reset Your Password</h1>
            <p className="instructions-subtitle">
              Reset your password using our mobile app
            </p>
          </div>

          <div className="app-downloads">
            <img
              src={appstore}
              alt="Download on App Store"
              className="store-image appstore-image"
              onClick={handleAppStoreClick}
            />

            <img
              src={playstore}
              alt="Get it on Google Play"
              className="store-image playstore-image"
              onClick={handlePlayStoreClick}
            />
          </div>

          <div className="instructions-body">
            <div className="instruction-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Open the app on your device</h3>
                <p>Launch the VReels app on your mobile device</p>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Go to Forgot Password</h3>
                <p>Navigate to the login screen and tap on "Forgot Password"</p>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Follow the reset instructions</h3>
                <p>Enter your mobile number and follow the steps to reset your password</p>
              </div>
            </div>

            <div className="instruction-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Return to login with your new password</h3>
                <p>Once reset, come back here and login with your new password</p>
              </div>
            </div>
          </div>

          <div className="instructions-footer">
            <button
              onClick={handleBackToLogin}
              className="btn btn-primary back-to-login-btn"
            >
              ← Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;

